import React from "react";
import { IFieldContext } from "../../../constants";
import { withField } from "../Field";
import { TInputLikeProps } from "../InputLike";
import * as S from "./styled";

export interface IProps
    extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "size" | "pattern">,
        IFieldContext,
        Omit<TInputLikeProps, "onClick" | "focused"> {
    pattern?: RegExp;
}

const TextInput = React.forwardRef<HTMLInputElement, IProps>(
    (
        {
            className,
            style,
            error,
            disabled,
            icon,
            lead,
            leadingEnhancement,
            trail,
            trailingEnhancement,
            pattern,
            onChange,
            ...props
        },
        ref
    ) => {
        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            if (pattern && pattern.test(e.target.value)) {
                onChange?.(e);
                return;
            }

            if (!pattern) {
                onChange?.(e);
            }
        };

        return (
            <S.InputLike
                className={className}
                style={style}
                error={error}
                disabled={disabled}
                lead={lead}
                leadingEnhancement={leadingEnhancement}
                icon={icon}
                trail={trail}
                trailingEnhancement={trailingEnhancement}
            >
                <S.Input ref={ref} disabled={disabled} onChange={handleChange} {...props} />
            </S.InputLike>
        );
    }
);

export default withField(TextInput);
